import { Dispatch, SetStateAction } from 'react'

import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'
import theme from '@totallymoney/ui/theme'

import formatNumberToCurrency from '@utils/formatNumberToCurrency'
import { formatLoanTermYears } from '@utils/loanDetailsFormUtils'

import { StyledLoanDetailsModalButton } from './LoanDetailsModalButton.styled'

interface LoanDetailsModalButtonProps {
    loanAmount: number
    loanTerm: number
    setIsLoanFormModalOpen: Dispatch<SetStateAction<boolean>>
}

const LoanDetailsModalButton = ({
    loanAmount,
    loanTerm,
    setIsLoanFormModalOpen,
}: LoanDetailsModalButtonProps) => (
    <StyledLoanDetailsModalButton
        onClick={() => setIsLoanFormModalOpen(true)}
        aria-label="Opens pop up to refine loan details"
    >
        <Stack
            space="space10"
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <Text variant="80">
                <b>Loan details:</b>{' '}
                <span>
                    {formatNumberToCurrency(loanAmount)} over{' '}
                    {formatLoanTermYears(loanTerm)}
                </span>
            </Text>

            <Icon
                aria-hidden="true"
                icon="editPencil"
                size={14}
                color={theme.grey120}
            />
        </Stack>
    </StyledLoanDetailsModalButton>
)

export default LoanDetailsModalButton
